import styled from 'styled-components';

export const UwStatusWrapperStyled = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 1.6rem 0;
`;

export const UwStatusStyled = styled.span`
  font-size: 1.6rem;
  padding-left: 0.4rem;
  line-height: 2.4rem;
`;
